import { Typography, Box, Button } from "@mui/material";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";

interface ContactBlockProps {
  name: string;
  phone: string;
  email: string;
}

const ContactBlock: React.FC<ContactBlockProps> = ({ name, phone, email }) => {
  return (
    <Box
      sx={{
        marginBottom: "24px",
      }}
    >
      <Typography
        color="white"
        variant="body1"
        sx={{
          fontWeight: "bold",
          marginBottom: "12px",
        }}
      >
        {name}
      </Typography>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <PhoneIcon
          color="primary"
          sx={{
            marginRight: "24px",
            width: "18px",
          }}
        />
        <Typography color="white" variant="subtitle1">
          {phone}
        </Typography>
      </Box>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <EmailIcon
          color="primary"
          sx={{
            marginRight: "24px",
            width: "18px",
          }}
        />
        <Typography color="white" variant="subtitle1">
          {email}
        </Typography>
      </Box>
    </Box>
  );
};

const CriFooter = () => {
  const getYear = () => {
    return new Date().getFullYear();
  };

  return (
    <Box
      sx={{
        backgroundColor: "#263238",
        paddingTop: "50px",
        paddingBottom: "50px",
        paddingLeft: {
          xs: "24px",
          md: "200px",
        },
        paddingRight: {
          xs: "24px",
          md: "200px",
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: {
            xs: "column",
            md: "row",
          },
        }}
      >
        <Box
          sx={{
            flexGrow: 1,
            flexBasis: 0,
          }}
        >
          <Typography
            color="white"
            variant="h6"
            sx={{ textAlign: "center", marginBottom: "24px" }}
          >
            CONTACT US
          </Typography>

          <ContactBlock
            name="Mary Mazur"
            phone="(262) 909-0552"
            email="consresearchinst.mazur@gmail.com"
          />
          <ContactBlock
            name="Gerould Wilhelm"
            phone="(630) 640-1402"
            email="consresearchinst.wilhelm@gmail.com"
          />
          <ContactBlock
            name="Kenneth Johnson"
            phone="(630) 640-2169"
            email="consresearchinst.johnson@gmail.com"
          />
        </Box>

        <Box sx={{ width: "50px" }} />

        <Box
          sx={{
            flexGrow: 1,
            flexBasis: 0,
          }}
        >
          <Typography
            color="white"
            variant="h6"
            sx={{ textAlign: "center", marginBottom: "24px" }}
          >
            LEARN MORE
          </Typography>

          <Typography variant="body1" color="white">
            We need ongoing financial support so that our researchers can
            continue their work on lichens, bees, ants, and vascular plants, and
            so that our illustrator can hand-color botanical drawings for
            educational public art works. Donors will be acknowledged in
            upcoming publications.
          </Typography>
        </Box>

        <Box sx={{ width: "50px" }} />

        <Box
          sx={{
            flexGrow: 1,
            flexBasis: 0,
          }}
        >
          <Typography
            color="white"
            variant="h6"
            sx={{ textAlign: "center", marginBottom: "24px" }}
          >
            SUPPORT
          </Typography>

          <Typography variant="body1" color="white">
            Every donation helps protect the incredible diversity of life on
            Earth. Join us in our mission to study, preserve, and ensure a
            thriving future for wildlife and plants.
          </Typography>

          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              marginTop: "50px",
            }}
          >
            <Button
              variant="contained"
              sx={{
                paddingLeft: "50px",
                paddingRight: "50px",
              }}
            >
              Donate
            </Button>
          </Box>
        </Box>
      </Box>

      <Typography
        variant="body1"
        color="white"
        sx={{ textAlign: "center", marginTop: "50px" }}
      >
        © {getYear()} Conservation Research Institute
      </Typography>
    </Box>
  );
};

export default CriFooter;
